export const importFields = {
    people: [
        {name:"id", label:"Source ID"}, 
        {name:"firstName", label:"First Name", required: true}, 
        {name:"lastName", label:"Last Name", required: true}, 
        {name:"gender", label:"Gender"}, 
        {name:"dateOfBirth", label:"Birthdate"}, 
        {name:"email", label:"Email"}, 
        {name:"phone", label:"Phone Number"}, 
        {name:"familyRole", label:"Family Role"}, 
        {name:"invitedByNote", label:"Invited By Note"}, 
        {name:"barcode", label:"Barcode"}, 
        {name:"isArchived", label:"Archived"}, 
        {name:"street", label:"Street Address"}, 
        {name:"streetLine2", label:"Street Address Line 2"}, 
        {name:"city", label:"City"}, 
        {name:"state", label:"State"}, 
        {name:"zip", label:"Zip Code"}
    ],
    transactions: [
        {name:"personID", label:"Payee", type:"people", associationName:"Person", required:true}, 
        {name:"amount", label:"Amount", required:true}, 
        {name:"fundID", label:"Fund", type:"contributionFunds", associationName:" Contribution Fund"}, 
        {name:"methodID", label:"Method", type:"contributionMethods", associationName:"Contribution Method"}, 
        {name:"methodDetailValue", label:"Method Detail"}, 
        {name:"transactionDate", label:"Date", required:true}, 
        {name:"note", label:"Note"},
        {name:"taxDeductible", label:"Tax Deductible"}, 
    ],
}

// Field-name groupings used by the people importer to route mapped columns to
// the correct destination (People columns, the Addresses table, phones, etc.).
export const personImportFieldGroups = {
    // Direct columns on the People table.
    personColumns: ["firstName", "lastName", "gender", "dateOfBirth", "email", "familyRole", "invitedByNote", "barcode", "isArchived"],
    // Columns that live on the related Addresses record.
    addressColumns: ["street", "streetLine2", "city", "state", "zip"],
    // Special handling.
    phoneField: "phone",
    idField: "id",
}